import React, { useEffect, useState } from 'react';
import { Button, AppBar, Toolbar, Typography, Box, useMediaQuery, IconButton, Drawer, List, ListItem, ListItemText, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu'; // Importing the hamburger menu icon
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';

const Navbar = ({ toggleTheme }) => {
  const navigate = useNavigate();
  const [isDark, setIsDark] = useState(true);
  const [drawerOpen, setDrawerOpen] = useState(false);

  // Check if the screen size is small (sm or smaller)
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  // Handle the theme toggle
  const handleToggleTheme = () => {
    setIsDark((prev) => {
      const next = !prev;
      localStorage.setItem('mode', next ? 'dark' : 'light'); // Save the mode to localStorage
      return next;
    });
    toggleTheme(); // This will toggle the theme in the parent component
  };

  useEffect(() => {
    const savedMode = localStorage.getItem('mode');
    if (savedMode) {
      setIsDark(savedMode === 'dark');
    }
  }, []);
  // Handle opening and closing of the drawer (hamburger menu)
  const toggleDrawer = () => {
    setDrawerOpen((prev) => !prev);
  };

  const themeToggleButton = (
    <Tooltip title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}>
      <IconButton color="inherit" onClick={handleToggleTheme} aria-label="Toggle color mode">
        {isDark ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}
      </IconButton>
    </Tooltip>
  );

  return (
    <AppBar position="sticky" color="default" elevation={0} sx={{ borderBottom: 1, borderColor: 'divider' }}>
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        <Box
          sx={{ display: 'flex', alignItems: 'center', gap: 1, cursor: 'pointer' }}
          onClick={() => navigate('/')}
        >
          <LockOutlinedIcon sx={{ color: 'primary.main' }} />
          <Typography variant="h6" component="div" sx={{ fontWeight: 700, letterSpacing: '-0.01em' }}>
            Share-a-Secret
          </Typography>
        </Box>

        {/* Show menu on small screens */}
        {isSmallScreen ? (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {themeToggleButton}
            <IconButton edge="end" color="inherit" onClick={toggleDrawer} aria-label="Open menu">
              <MenuIcon />
            </IconButton>
            <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer}>
              <List sx={{ minWidth: 220 }}>
                <ListItem button onClick={() => { navigate('/'); toggleDrawer(); }}>
                  <ListItemText primary="Create a Secret" />
                </ListItem>
                <ListItem button onClick={() => { navigate('/api/docs'); toggleDrawer(); }}>
                  <ListItemText primary="API Docs" />
                </ListItem>
                <ListItem button onClick={() => { navigate('/faq'); toggleDrawer(); }}>
                  <ListItemText primary="FAQ" />
                </ListItem>
              </List>
            </Drawer>
          </Box>
        ) : (
          // Regular layout for larger screens
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Button color="inherit" onClick={() => navigate('/')}>
              Create a Secret
            </Button>
            <Button color="inherit" onClick={() => navigate('/api/docs')}>
              API Docs
            </Button>
            <Button color="inherit" onClick={() => navigate('/faq')}>
              FAQ
            </Button>
            {themeToggleButton}
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
